// tslint:disable:max-line-length

import React from 'react';

export const ActionAttach = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg viewBox="0 0 16 16" {...props}>
      <path d="M9.8,6.7l0.4-0.5L9.1,5.1l-4.9,4.9c-0.3,0.3-0.4,0.9-0.4,1.3c0.1,0.3,0.2,0.9,0.6,1.3c0.3,0.3,0.8,0.5,1.2,0.5 c0.5,0,0.9-0.2,1.3-0.5l7.3-7.3c0.6-0.6,0.9-1.4,0.9-2.3s-0.3-1.7-0.9-2.3C13.6,0.3,12.8,0,11.9,0h-0.3c-1,0-1.7,0.6-2,0.9L2.3,8.2 c-0.9,0.9-1.4,2.1-1.4,3.3s0.5,2.4,1.4,3.3C3.1,15.6,4.1,16,5.2,16c1.3,0,2.5-0.5,3.5-1.6l4.9-4.9l-1.1-1.1l-5,4.9 c-0.6,0.7-1.5,1-2.1,1.1c-0.8,0.1-1.4-0.2-2.1-0.8c-0.6-0.6-0.9-1.3-0.9-2.2s0.3-1.6,0.9-2.2L10.7,2c0.7-0.7,1.6-0.7,2.3,0 c0.3,0.3,0.5,0.7,0.5,1.2S13.4,4,13.1,4.4l-7.3,7.2c-0.1,0.1-0.1,0.1-0.2,0c-0.1-0.2-0.2-0.4-0.1-0.4L9.8,6.7z" />
    </svg>
  );
};
